var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BarChartGenerator',{attrs:{"chart-id":_vm.chartId,"dataset-id-key":_vm.chartId,"chart-options":_vm.chartOptions,"chart-data":_vm.chartData}})
}
var staticRenderFns = []

export { render, staticRenderFns }